import React from 'react';
import { themeVars } from '@eds-web/react';

import { PrizeSummary } from './PrizeSummary';
import { Winning } from '../../types/prize.types';
import { useSelector } from 'react-redux';
import { selectPrizesOffline } from '../../selectors/prize.selector';
import {
    isPrizeClaimed,
    isPrizeOffline,
    isPrizeCash,
    isFRMinorPrize
} from '../../utils/prizeUtils';
import { usePrizeHeaderData } from '../../hooks/usePrizeHeaderData';
import { CompletedPrize } from './CompletedPrize';
import styled from '@emotion/styled';

interface PrizeProps {
    winning: Winning;
}

const PrizeSummaryInfo = styled.div`
    padding: 0 24px;
    border-radius: 16px;
    background-color: ${themeVars.color.background.elevated.medium};
`;

export const Prize: React.FC<PrizeProps> = ({ winning }) => {
    const offlinePrize = useSelector(selectPrizesOffline);
    const headerData = usePrizeHeaderData(winning);
    const isClaimed = isPrizeClaimed(winning);
    const isOffline = isPrizeOffline(winning, offlinePrize);
    const isCash = isPrizeCash(winning);
    const isFRMinor = isFRMinorPrize(winning, offlinePrize);

    return (
        <>
            <PrizeSummaryInfo>
                <PrizeSummary
                    gameId={winning?.gameId}
                    headerData={headerData}
                    prizeId={winning.prizeId}
                    showClaimButton={!isClaimed}
                />
                {isClaimed && (
                    <CompletedPrize isCash={isCash} isFRMinor={isFRMinor} isOffline={isOffline} />
                )}
            </PrizeSummaryInfo>
        </>
    );
};
